<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <template-list @templates-loading-state="loadingState = $event" />
    </b-overlay>
  </b-card>
</template>

<script>
import { BOverlay, BCard } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import TemplateList from '../components/TemplateList.vue'

export default {
  components: {
    TemplateList,
    BOverlay,
    BCard,
  },
  setup() {
    const loadingState = ref(true)
    return {
      loadingState,
    }
  },
}
</script>

<style>

</style>
